import { toast } from "react-toastify";
import {
  fetchDailyReportSheetFailure,
  fetchDailyReportSheetStart,
  fetchDailyReportSheetSuccess,
} from "./reducer";
import { getDailyReportService } from "../../Services/ReportService";

// //thunk for fetch the category list
export const fetchDailyTriReport =
  (params = {}) =>
  async (dispatch) => {
    try {
      dispatch(fetchDailyReportSheetStart());
      const response = await getDailyReportService(params);
      if (response) {
        // const currentPagination = getState().MealCategory.pagination;
        // dispatch(
        //   fetchDailyReportSheetSuccess({
        //     report: response,
        //   })
        // );

        const blob = response.data;
        const headers = response.headers;

        let fileName = "DailyTripReport.xlsx";
        const contentDisposition = headers["content-disposition"];

        if (contentDisposition) {
          const match = contentDisposition.match(/filename="?([^"]+)"?/);
          if (match && match.length > 1) {
            fileName = match[1];
          }
        }

        const url = window.URL.createObjectURL(new Blob([blob]));

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName); // Set filename

        // Trigger download
        document.body.appendChild(link);
        link.click();

        // Cleanup
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);

        toast.success("Report downloaded successfully");
      } else {
        dispatch(fetchDailyReportSheetFailure("No data found"));
      }
    } catch (error) {
      dispatch(fetchDailyReportSheetFailure(error));
    }
  };

// //thunk for the addig the category

// export const addSupplier = (requestParam) => async (dispatch) => {
//   try {
//     dispatch(addSupplierStart());

//     const response = await addSupplierService(requestParam);

//     if (response?.success) {
//       toast.success(response.message);
//       dispatch(addSupplierSuccess(response));
//     } else {
//       toast.error("Something went wrong ");
//       dispatch(addSupplierFailure("Failed to add Supplier"));
//     }
//   } catch (error) {
//     toast.error(error);

//     dispatch(addSupplierFailure(error));
//   }
// };

// // //this is the thunk for delete the category
// export const deleteSupplier = (supplierId) => async (dispatch) => {
//   try {
//     dispatch(deleteSupplierStart());

//     const response = await deleteSupplierService(supplierId);

//     if (response?.success) {
//       toast.success(response.message);
//       dispatch(deleteSupplierSuccess(supplierId));
//     } else {
//       toast.error("Failed to delete supplier");
//       dispatch(deleteSupplierFailure("Delete failed"));
//     }
//   } catch (error) {
//     toast.error(error);
//     dispatch(deleteSupplierFailure(error));
//   }
// };

// // //this tunk for the edit meal category
// export const editSupplier = (requestParam) => async (dispatch) => {
//   try {
//     dispatch(editSupplierStart());

//     const response = await editSupplierService(requestParam);

//     if (response?.success) {
//       toast.success(response.message);
//       dispatch(editSupplierSuccess(response));
//     } else {
//       dispatch(editSupplierFailure("Failed to update supplier"));
//     }
//   } catch (error) {
//     toast.error(error);
//     dispatch(editSupplierFailure(error));
//   }
// };

// //this thunk is for the get by id
// export const fetchMealCategoryById = (id) => async (dispatch) => {
//   try {
//     dispatch(getCategoryByIdStart());
//     const response = await getCategoryByIdService(id);
//     if (response?.data) {
//       dispatch(getCategoryByIdSuccess(response.data));
//     } else {
//       dispatch(getCategoryByIdFailure("No category found"));
//     }
//   } catch (error) {
//     toast.error(error);
//     dispatch(getCategoryByIdFailure(error));
//   }
// };
